import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.svg";
import close from "../../assets/images/close.svg";
import LanguageSelection from "./LanguageSelection";
import { useDispatch, useSelector } from "react-redux";
import { changeShowMenu } from "../../redux/slices/showMenuSlice";
import { IoChevronDown } from "react-icons/io5";
import { motion, AnimatePresence } from "framer-motion";
import { fetchContact } from "../../redux/slices/contactSlice";
import { fetchContent } from "../../redux/slices/contentSlice";
import { fetchMenuGroup } from "../../redux/slices/menuGroupSlice";

const MobileHeader = () => {
  const { t } = useTranslation();
  const lang = useSelector((state) => state.lang.lang);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const showMenu = useSelector((state) => state.showMenu.showMenu);
  const { dataMenuGroup } = useSelector((state) => state.menuGroup);
  const { dataContent } = useSelector((state) => state.content);

  const dispatch = useDispatch();
  const { dataContact } = useSelector((state) => state.contact);

  useEffect(() => {
    dispatch(fetchContact());
    dispatch(fetchContent());
    dispatch(fetchMenuGroup());
  }, [dispatch]);

  let headerMenus = [];

  if (Array.isArray(dataMenuGroup)) {
    const headerMenuGroup = dataMenuGroup.find(
      (group) => group?.title?.[lang] === "Footer Menu"
    );
    if (headerMenuGroup && Array.isArray(headerMenuGroup.menus)) {
      headerMenus = headerMenuGroup.menus;
    }
  }

  const contact = dataContact || {};
  const content = dataContent || {};
  const company = contact.company?.[lang] || "";
  const companyDescription = contact.companyDescription?.[lang] || "";
  const specialField1 = contact.specialField1?.[lang] || "";
  const copyright = content.footerText2?.[lang] || "";

  return (
    <AnimatePresence>
      {showMenu && (
        <motion.div
          className="mobile-header"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div
            className="menu"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
          >
            <div className="logo">
              <div>
                <Link onClick={() => dispatch(changeShowMenu(false))} to="/">
                  <img src={logo} alt="" />
                </Link>
              </div>
              <div onClick={() => dispatch(changeShowMenu(false))}>
                <img src={close} alt="" />
              </div>
            </div>
            <div className="content">
              <div className="w-100 my-2 d-flex justify-content-center align-items-center">
                <LanguageSelection />
              </div>
              <div className="menu-txt">
                <span>{t("menu")}</span>
              </div>
              <ul>
                <li>
                  {/* <Link onClick={() => dispatch(changeShowMenu(false))} to="/">
                    {t("homepage")}
                  </Link> */}

                  {headerMenus
                    .slice()
                    .sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0))
                    .map((menu) => (
                      <li key={menu.id}>
                        <Link
                          onClick={() => dispatch(changeShowMenu(false))}
                          to={`/${menu.slug?.[lang] || ""}`}
                        >
                          {menu.title?.[lang] || ""}
                        </Link>
                      </li>
                    ))}
                </li>
                {/* <li>
                  <div className="submenu-title">
                    <Link
                      onClick={() => dispatch(changeShowMenu(false))}
                      to={
                        lang === "tr" ? "/urun-aileleri" : "/product-families"
                      }
                    >
                      {t("product_family")}
                    </Link>
                    
                  </div>
                  <AnimatePresence>
                    {submenuOpen && (
                      <motion.ul
                        className="submenu"
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.3 }}
                        style={{ overflow: "hidden" }}
                      >
                        <li>
                          <Link
                            onClick={() => dispatch(changeShowMenu(false))}
                            to="/"
                          >
                            {t("jiroskop")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={() => dispatch(changeShowMenu(false))}
                            to="/"
                          >
                            {t("driver_family")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={() => dispatch(changeShowMenu(false))}
                            to="/"
                          >
                            {t("antenna_family")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={() => dispatch(changeShowMenu(false))}
                            to="/"
                          >
                            {t("unit_family")}
                          </Link>
                        </li>
                      </motion.ul>
                    )}
                  </AnimatePresence>
                </li> */}
                {/* <li>
                  <Link
                    onClick={() => dispatch(changeShowMenu(false))}
                    to={lang === "tr" ? "/hakkimizda" : "/about"}
                  >
                    {t("about")}
                  </Link>
                </li> */}
                {/* <li>
                  <Link
                    onClick={() => dispatch(changeShowMenu(false))}
                    to={lang === "tr" ? "/haberler" : "/news"}
                  >
                    {t("news")}
                  </Link>
                </li> */}
                {/* <li>
                  <Link
                    onClick={() => dispatch(changeShowMenu(false))}
                    to={lang === "tr" ? "/iletisim" : "/contact"}
                  >
                    {t("contact")}
                  </Link>
                </li> */}
              </ul>
              <div className="bottom">
                <div>
                  <span className="company">{company}</span>
                </div>
                <div className="mt-2">
                  <span className="address">{companyDescription}</span>
                </div>

                <div className="mt-3">
                  <span className="copyright">{copyright}</span>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileHeader;
